export const ApiCall = async (
  url,
  method,
  params,
  token = null,
  file = false
) => {
  let headersP = !file
    ? {
        "Accept-Type": "application/json",
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
      }
    : {};
  const h = token
    ? { ...headersP, Authorization: "Bearer " + token }
    : headersP;
  const json = await fetch(url, {
    method: method,
    body: params,
    headers: h,
  })
    .then((response) =>
      response.status < 400 ? response.json() : console.log("Error")
    )
    .catch((err) => console.log(err))
    .then((data) => data);

  return json;
};
export const ApiCallNQ = async (url, method, params, file = false) => {
  const headersP = !file
    ? { "Accept-Type": "application/json", "Content-Type": "application/json" }
    : {};

  const response = await fetch(url, {
    method: method,
    body: params,
    headers: headersP,
  });
  return response.status === 200 || response.status === 201;
};
export const ApiDownload = async (url, params, filename) => {
  const json = await fetch(url, {
    method: "POST",
    body: params,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    responseType: "blob",
  })
    .then((response) => response.blob())
    .catch((err) => console.log(err))
    .then((file) => {
      var fileDownload = require("js-file-download");
      file && fileDownload(file, filename);
    });
  return json;
};

export const ApiGetImage = async (url, params) => {
  const json = await fetch(url, {
    method: "POST",
    body: params,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    responseType: "blob",
  })
    .then((response) => response.blob())
    .catch((err) => console.log(err))
    .then((file) => {
      var objectURL = URL.createObjectURL(file);
      return objectURL;
    });
  return json;
};
